module.exports = __webpack_public_path__ + "static/media/zeya_walk_04_s.5728909a.svg";